export const themeConfig = themeColor => {
  const color = themeColor.includes("#") ? themeColor : "#" + themeColor;

  const root = document.documentElement;
  if (root) {
    root.style.setProperty("--ts_primary", color);
    root.style.setProperty("--ts_secondary", color + "95");
  }
};
